import { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { MainLayout } from 'views/layouts'
import {
  Container,
  Row,
  ButtonsContainer,
  TextBoldViolet,
  ActionContainer,
  StateButton,
} from './styled'
import ModalLoader from 'views/components/UI/ModalLoader/modal-loader'
import SearchBar from 'views/components/Searchbar/search-bar'
import { BackButton } from 'views/components/UI/Buttons'
import { H2 } from 'views/components/UI/Text'
import { useNotification } from 'lib/context/notification.context'
import BluesiteTable from 'views/components/UI/BluesiteTable'
import { ActionSendReminder } from 'views/components/UI/BluesiteTable/Actions/GridActions'
import { useFetchGetResumeProcess, useFetchGetUsersByProcess } from 'hooks/process/useGetProcess/useGetProcess'
import sendReminderTestToUserService from 'services/common/reports/postReminderTestToUser/postReminderTestToUser'
import { DEFAULT_LIMIT } from 'constants/global.constants'
import { isDateMoreThan24HoursOld } from 'utils/formatDate'

const HEADERS_GRID_TEST_360 = [
  { name: 'Documento', key: 'document' },
  { name: 'Correo', key: 'email' },
  { name: 'Nombre', key: 'first_name' },
  { name: 'Apellido', key: 'last_name' },
  { name: 'Estado', key: 'status' },
]

interface FilterGetUsersByProcess {
  limit?: number
  page?: number
  search?: string
  complete?: boolean
  evaluatedOnly?: boolean
  retrieveAllUsers?: boolean
}

const EvaluatorsTest360 = () => {
  const { getSuccess, getError } = useNotification()
  const navigate = useNavigate()
  const location = useLocation()
  const [filterGetUSers, setFilterGetUsers] = useState<FilterGetUsersByProcess>({
    limit: DEFAULT_LIMIT,
    complete: false,
    evaluatedOnly: false,
    retrieveAllUsers: true,
  })
  const [reload, setReload] = useState(false)
  const [loading, setLoading] = useState(false)
  const [search, setSearch] = useState('')

  const { id } = location.state as any
  const { listUsersByProcess, loadingUsersByProcess, fetchUsers, totalPages } = useFetchGetUsersByProcess(
    id,
    filterGetUSers
  )
  const { listProcessTestResume, loadingProcessResume, fetchProcessResume } = useFetchGetResumeProcess(id)

  const [usersCheckBox, setUsersCheckBox] = useState<Set<number>>(new Set())

  useEffect(() => {
    fetchUsers()
    fetchProcessResume()
  }, [fetchUsers, fetchProcessResume, reload])

  useEffect(() => {
    if (search.length > 0) {
      setFilterGetUsers({ ...filterGetUSers, search, page: 1, complete: false })
    } else {
      const filtersMofiied = { ...filterGetUSers, complete: false }
      delete filtersMofiied.search
      setFilterGetUsers(filtersMofiied)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search])

  const handlePagination = async (page: number) => {
    setFilterGetUsers({ ...filterGetUSers, limit: DEFAULT_LIMIT, page })
  }

  const handleSetFilterGetUsers = (searchTerm: string) => {
    setFilterGetUsers({ search: searchTerm })
  }

  const dataUsers = Array.from(new Set(listUsersByProcess?.map((user: any) => user.userId)))
    .map((userId: any, index: number) => {
      const currentUserData = listUsersByProcess?.filter((user: any) => user.userId === userId)

      if (!currentUserData) {
        return null
      }

      const hasUserWithNonEmptyReminder = currentUserData.some((user: any) => user.test_reminder !== null)
      const filteredUsers = hasUserWithNonEmptyReminder
        ? currentUserData.filter((user: any) => user.test_reminder !== null)
        : currentUserData

      const userData = filteredUsers[0]

      return {
        ...userData,
        tests: (
          <div>
            {userData.completedTests}/{userData.totalTests}
          </div>
        ),
        index: index,
        testReminder: userData.test_reminder,
      }
    })
    .filter(Boolean)

  const handleSendReminderToSingleUser = async (emailUser: string) => {
    const email = {
      emails: [{ email: emailUser }],
    }
    try {
      const dataResponse = await sendReminderTestToUserService(email, id)
      if (dataResponse.data[0].status) {
        getSuccess('Recordatorio enviado exitosamente')
      }
    } catch (error) {
      getError('Ha ocurrido un error al enviar el recordatorio')
    }
  }

  const handleSendReminderToMultipleUsers = async () => {
    const emailsToSend = Array.from(usersCheckBox)
      .map((userId) => {
        const user = dataUsers.find((item) => item.userId === userId)
        return user ? { email: user.email } : null
      })
      .filter((emailObj): emailObj is { email: string } => emailObj !== null)
      .map((email) => ({ emails: [email] }))

    const promises = emailsToSend.map((emailObj) => sendReminderTestToUserService(emailObj, id))

    try {
      const results = await Promise.allSettled(promises)

      const rejected = results.filter((result) => result.status === 'rejected')
      const fulfilled = results.filter((result) => result.status === 'fulfilled' && result.value.data[0].status)

      setUsersCheckBox(new Set())

      if (rejected.length > 0) {
        getError('No se pudo enviar las pruebas a todos los usuarios')
      } else if (fulfilled.length === emailsToSend.length) {
        getSuccess('Recordatorios enviados exitosamente')
      } else {
        getError('No se pudo enviar las pruebas a todos los usuarios')
      }
      setLoading(true)
      setReload(!reload)
      setTimeout(() => {
        setLoading(false)
      }, 2000)
    } catch (error) {
      getError('Ha ocurrido un error inesperado al enviar los recordatorios')
    }
  }

  const modifiedDataUsers = dataUsers.map((user) => {
    return {
      ...user,
      id: user.userId,
    }
  })

  const EvaluationStateComponent = (item: any) => {
    const getStateConfig = (state: string) => {
      switch (state) {
        case 'completed':
          return { text: 'Finalizado', backgroundColor: '#84E6B7', color: '#000000' }
        case 'started':
          return { text: 'En proceso', backgroundColor: '#FAE0A8', color: '#000000' }
        case 'closed':
          return { text: 'Cerrado', backgroundColor: '#E69090', color: '#000000' }
        case 'pending':
        default:
          return { text: 'Sin iniciar', backgroundColor: '#CFCFCF', color: '#000000' }
      }
    }

    const config = getStateConfig(item.self_evaluation_status)

    return (
      <ActionContainer>
        <StateButton backgroundColor={config.backgroundColor} color={config.color}>
          {config.text}
        </StateButton>
      </ActionContainer>
    )
  }

  const test360DataUsers = modifiedDataUsers
    .filter((user) => user.is_evaluator === true)
    .map((user) => ({
      ...user,
      document: user.document,
      email: user.email,
      first_name: user.first_name,
      last_name: user.last_name,
      status: <EvaluationStateComponent self_evaluation_status={user.self_evaluation_status} />,
      self_evaluation_status: user.self_evaluation_status,
    }))

  return (
    <MainLayout>
      {listUsersByProcess ? (
        <Container>
          <H2>Evaluadores</H2>
          <Row
            width="100%"
            height="48px"
            margin="140px 0px 30px 0px"
            style={{ justifyContent: 'space-between', alignItems: 'center' }}
          >
            <SearchBar
              label="Buscar por nombre, correo, documento"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value)
              }}
              onClick={() => handleSetFilterGetUsers(search)}
              style={{ margin: '0px 0px 0px 0px', width: 'auto' }}
            />
            {usersCheckBox.size > 0 && (
              <ButtonsContainer>
                <TextBoldViolet onClick={handleSendReminderToMultipleUsers}>Enviar recordatorio</TextBoldViolet>
              </ButtonsContainer>
            )}
          </Row>

          <BluesiteTable
            loading={loading || loadingUsersByProcess}
            headers={HEADERS_GRID_TEST_360}
            data={test360DataUsers}
            searchBar={false}
            showNumbers={true}
            checks={listProcessTestResume?.test_360 ? false : true}
            selectedItems={usersCheckBox}
            setSelectedItems={setUsersCheckBox}
            hideMainCheckbox
            searchLabel=""
            totalPages={totalPages}
            handlePagination={handlePagination}
            currentPage={filterGetUSers.page ? filterGetUSers.page : 1}
            ActionComponent={ActionSendReminder}
            extraDataAction={{
              disabled: usersCheckBox.size > 0,
              onSendReminder: (e: string) => handleSendReminderToSingleUser(e),
              isDateMoreThan24HoursOld: isDateMoreThan24HoursOld,
            }}
          />
          <BackButton onClick={() => navigate(-1)} />
        </Container>
      ) : (
        <ModalLoader isLoading={loadingProcessResume} />
      )}
    </MainLayout>
  )
}

export default EvaluatorsTest360
